import React from "react";
import { LANDING } from "@/constants/testIds";

/**
 * "Platform Posture" — forward-looking institutional metrics strip.
 * For a platform in formation we lead with posture / discipline numbers
 * rather than fabricated AUM. Inspired by KKR / Blackstone hero strips.
 */
const METRICS = [
  { value: "4", label: "Investment Mandates" },
  { value: "12+", label: "Target Industrial Sectors" },
  { value: "3", label: "Jurisdictions of Engagement" },
  { value: "100%", label: "Senior-Secured Bias" },
  { value: "IC", label: "Documented Underwriting" },
];

const PlatformPosture = () => {
  return (
    <section
      data-testid={LANDING.platformPosture}
      className="relative border-t border-b border-[var(--kr-line)]"
      style={{ background: "#070a0f" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-12">
        <div className="flex items-center gap-4 mb-10">
          <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
            Platform Posture
          </span>
          <span className="w-12 h-px bg-[var(--kr-gold)]/60" />
          <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)]">
            Forward-Looking · In Strategic Formation
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-0 border-l border-[var(--kr-line)]">
          {METRICS.map((m, i) => (
            <div
              key={m.label}
              className="px-6 py-7 border-r border-t border-b border-[var(--kr-line)]"
              style={i % 2 === 1 ? { background: "rgba(201,169,110,0.02)" } : {}}
            >
              <div className="font-serif-display text-[2.2rem] md:text-[2.7rem] text-[var(--kr-text)] leading-none">
                {m.value}
              </div>
              <div className="font-mono-label text-[10px] text-[var(--kr-text-muted)] mt-4">
                {m.label}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-[var(--kr-text-dim)] text-[12px] leading-[1.7] max-w-[100ch]">
          Metrics describe the platform's intended posture and underwriting bias
          during formation. They do not constitute representations of capital
          raised, deployed or committed.
        </p>
      </div>
    </section>
  );
};

export default PlatformPosture;
